/** Votiq mark (40×40) — inlined so the embed works on any host. */
export const VOTIQ_LOGO_MARK_SVG = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" fill="none" aria-hidden="true">
  <rect width="40" height="40" rx="10" fill="#AAF775"/>
  <path d="M11.5 13.5 L20 28.5" stroke="#001715" stroke-width="5.5" stroke-linecap="round"/>
  <path d="M28.5 13.5 L20 28.5" stroke="#001715" stroke-width="5.5" stroke-linecap="round"/>
</svg>`;

/** Monochrome mark for footer — uses currentColor (light/dark panel). */
export const VOTIQ_LOGO_MARK_MONO_SVG = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" fill="none" aria-hidden="true">
  <rect width="40" height="40" rx="10" fill="currentColor" fill-opacity="0.14"/>
  <path d="M11.5 13.5 L20 28.5" stroke="currentColor" stroke-width="5.5" stroke-linecap="round"/>
  <path d="M28.5 13.5 L20 28.5" stroke="currentColor" stroke-width="5.5" stroke-linecap="round"/>
</svg>`;

/** V mark only — floating launcher (no background tile behind the icon). */
export const VOTIQ_LOGO_MARK_LAUNCHER_SVG = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" fill="none" aria-hidden="true">
  <path d="M11.5 13.5 L20 28.5" stroke="currentColor" stroke-width="5.5" stroke-linecap="round"/>
  <path d="M28.5 13.5 L20 28.5" stroke="currentColor" stroke-width="5.5" stroke-linecap="round"/>
</svg>`;
